function formatFileSize(size) {
  const sizes = [
    ' Octets',
    ' Ko',
    ' Mo',
    ' Go',
    ' To',
    ' Po',
    ' Eo',
    ' Zo',
    ' Yo'
  ];
  for (var i = 1; i < sizes.length; i++) {
    if (size < Math.pow(1024, i))
      return (
        Math.round((size / Math.pow(1024, i - 1)) * 100) / 100 + sizes[i - 1]
      );
  }
  return size;
}
export { formatFileSize };
